export const REQUIREMENT_PERMISSIONS = {
  workspace: {
    view: 'requirement:workspace:view',
  },
  record: {
    view: 'requirement:record:view',
    create: 'requirement:record:create',
    update: 'requirement:record:update',
    delete: 'requirement:record:delete',
  },
  task: {
    view: 'requirement:task:view',
    create: 'requirement:task:create',
    update: 'requirement:task:update',
    delete: 'requirement:task:delete',
  },
  bug: {
    view: 'requirement:bug:view',
    create: 'requirement:bug:create',
    update: 'requirement:bug:update',
    delete: 'requirement:bug:delete',
  },
  iteration: {
    view: 'requirement:iteration:view',
    create: 'requirement:iteration:create',
    update: 'requirement:iteration:update',
    delete: 'requirement:iteration:delete',
  },
  analytics: {
    view: 'requirement:analytics:view',
    export: 'requirement:analytics:export',
  },
  savedView: {
    view: 'requirement:saved_view:view',
    create: 'requirement:saved_view:create',
    update: 'requirement:saved_view:update',
    delete: 'requirement:saved_view:delete',
  },
} as const

export type RequirementPermissionAction = 'view' | 'create' | 'update' | 'delete'
export type RequirementWorkItemType = 'REQUIREMENT' | 'TASK' | 'BUG' | 'ITERATION'

type WorkItemPermissionResource = 'record' | 'task' | 'bug' | 'iteration'

const WORK_ITEM_PERMISSION_RESOURCE: Record<RequirementWorkItemType, WorkItemPermissionResource> = {
  REQUIREMENT: 'record',
  TASK: 'task',
  BUG: 'bug',
  ITERATION: 'iteration',
}

export function getWorkItemPermissions(type: RequirementWorkItemType) {
  return REQUIREMENT_PERMISSIONS[WORK_ITEM_PERMISSION_RESOURCE[type]]
}

export function getWorkItemPermission(
  type: RequirementWorkItemType,
  action: RequirementPermissionAction,
) {
  return getWorkItemPermissions(type)[action]
}
